import { QUEUE } from '../types/interface';
export class Queue implements QUEUE {
    // 正操作下标
    headIndex: number;
    // 添加数据下标
    tailIndex: number;
    // 存储数据的数据结构
    items: any[];
    // 对象初始化
    constructor() {
        this.items = [];
        this.headIndex = 0;
        this.tailIndex = 0;
    }
    // 添加数据
    add(params: any) {
        this.items[this.tailIndex] = params;
        this.tailIndex++;
    }
    // 处理数据
    dequeue(): any {
        const item = this.items[this.headIndex];
        delete this.items[this.headIndex];
        this.headIndex++;
        return item;
    }
    // 获取待处理数据的第一条
    peek(): any {
        return this.items[this.headIndex];
    }
    // 待处理数据的长度
    length(): number {
        return this.tailIndex - this.headIndex;
    }
}
